import { Controller } from "@hotwired/stimulus"
import { requestConfirm, pluralize } from "../util"

export default class extends Controller {
  static targets = ["form", "confirmButton"]
  static values = { usersCount: Number }

  confirmDisable(event) {
    event.preventDefault()

    const selectedPermissions = this.extractSelectedPermissions()
    const usersLabel = pluralize(this.usersCountValue, "User", "Users")

    this.requestConfirmAndSubmit(
      "confirm-users-permissions",
      { title: `Disable ${selectedPermissions} for ${usersLabel}` }
    )
  }

  canSubmitForm() {
    if (this.hasConfirmButtonTarget) {
      this.confirmButtonTarget.disabled = !this.hasSelectedPermissions()
    }
  }

  async requestConfirmAndSubmit(modal, data) {
    const confirmed = await requestConfirm({ modal, data })
    if (!confirmed) return

    this.submitFormAndClose()
  }

  submitFormAndClose() {
    this.formTarget.requestSubmit()
    this.element.dispatchEvent(new CustomEvent("drawer:close", { bubbles: true }))
    this.element.dispatchEvent(new CustomEvent("table-checkboxes:clear", { bubbles: true }))
  }

  hasSelectedPermissions() {
    return this.checkedPermissionCheckboxes().length > 0
  }

  extractSelectedPermissions() {
    return this.checkedPermissionCheckboxes()
      .map(checkbox => `'${checkbox.closest("label").querySelector("span").textContent.trim()}'`)
      .join(", ")
  }

  checkedPermissionCheckboxes() {
    return Array.from(this.element.querySelectorAll("input[type='checkbox']:checked"))
  }
}
